// Shim re-export to preserve existing import path
// The system-prompt command has been folderized under ./system-prompt/
export { systemPromptCommand } from "./system-prompt/index.js";
